// @ts-nocheck
import { gql } from '__generated__'

export const GET_SMART_CONTRACTS = gql(`
  query getSmartContracts {
    getSmartContracts {
      contractName
      contracts {
        active
        chainIdentifier
        chainType
        contractAddress
        contractName
        meta {
          amount
          fee
          ownerFee
          token
          asset
          isMultiParticipation
        }
        version
      }
    }
  }
`)
